import React from "react";

import { css, cx } from "@emotion/css";

import { usePatientIdFromURL } from "@/hooks/usePatientIdFromURL.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Queries } from "@/queries/Queries.ts";
import { Dot } from "@/uiKit/atoms/Dot.tsx";

export type UnreadMessagesDotProps = {
  className?: string;
};

export const UnreadMessagesDot: React.FC<UnreadMessagesDotProps> = ({ className }) => {
  const styles = useStyles(makeStyles);
  const patientId = usePatientIdFromURL();
  const unreadMessages = Queries.messaging.useUnreadMessages({
    patientId,
  });

  return unreadMessages.fromPatient + unreadMessages.fromPractitioner ? (
    <Dot color="error" className={cx(styles.root, className)} size="caption" />
  ) : null;
};

const makeStyles = () => ({
  root: css({}),
});
